import React from "react";

/**
 * Animated D20 face with the rolled number.
 * If `rolling` is true, shows spin animation with "?".
 */
export default function D20Icon({ value, rolling = false, size = 56, className = "" }) {
  const display = rolling ? "?" : value;
  const isCrit = !rolling && value === 20;
  const isFumble = !rolling && value === 1;

  const fill = isCrit
    ? "#E68A00"
    : isFumble
    ? "#6b1f1f"
    : "#1d181c";
  const stroke = isCrit ? "#FFD37A" : isFumble ? "#ff7676" : "#D4AF37";
  const txtColor = isCrit ? "#1c1209" : isFumble ? "#ffe5e5" : "#f0ead6";

  return (
    <div
      className={`relative inline-flex items-center justify-center ${className} ${rolling ? "dice-spin" : ""}`}
      style={{ width: size, height: size }}
      data-testid="d20-icon"
      data-value={value ?? ""}
    >
      <svg viewBox="0 0 100 100" width={size} height={size} className="drop-shadow-[0_0_12px_rgba(230,138,0,0.45)]">
        <defs>
          <linearGradient id="d20grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={fill} stopOpacity="1" />
            <stop offset="100%" stopColor="#0a0709" stopOpacity="1" />
          </linearGradient>
        </defs>
        {/* outer icosahedron silhouette (pentagon outline) */}
        <polygon
          points="50,5 95,30 80,85 20,85 5,30"
          fill="url(#d20grad)"
          stroke={stroke}
          strokeWidth="2"
        />
        {/* inner facets */}
        <polygon
          points="50,5 80,85 20,85"
          fill="none"
          stroke={stroke}
          strokeOpacity="0.55"
          strokeWidth="1.2"
        />
        <polygon
          points="50,5 95,30 80,85"
          fill="none"
          stroke={stroke}
          strokeOpacity="0.35"
          strokeWidth="1"
        />
        <polygon
          points="50,5 5,30 20,85"
          fill="none"
          stroke={stroke}
          strokeOpacity="0.35"
          strokeWidth="1"
        />
        <text
          x="50"
          y="62"
          textAnchor="middle"
          fontFamily="'Cormorant Garamond', serif"
          fontWeight="700"
          fontSize={display !== undefined && String(display).length > 1 ? "34" : "42"}
          fill={txtColor}
        >
          {display ?? ""}
        </text>
      </svg>
    </div>
  );
}
